// extracted by mini-css-extract-plugin
export default {"contentWrap":"cPT2Q","loginButton":"Fdmpe","group":"jvJXy","tagWrap":"iFB4i","slideText":"JJ5_w"};